import {
  put, take, takeEvery, all, call,
} from 'redux-saga/effects';
import { channel } from 'redux-saga';
import NotificationsApi from './notifications.api';
import PushNotificationService from '../../../services/push-notification-service';
import ErrorFormatService from '../../../services/error-format-service';
import {
  GET_NOTIFICATION_LIST_DATA, GET_NOTIFICATION_LIST_DATA_SUCCESS, GET_NOTIFICATION_LIST_DATA_ERROR,
  DELETE_NOTIFICATION, DELETE_NOTIFICATION_SUCCESS, DELETE_NOTIFICATION_ERROR,
  DELETE_ALL_NOTIFICATIONS, DELETE_ALL_NOTIFICATIONS_SUCCESS, DELETE_ALL_NOTIFICATIONS_ERROR,
  NOTIFICATION_ADDED, NOTIFICATION_ADDED_SUCCESS, NOTIFICATION_ADDED_ERROR, NOTIFICATION_ADDED_SUBSCRIBED_SUCCESS,
  READ_NOTIFICATIONS, READ_NOTIFICATIONS_SUCCESS, READ_NOTIFICATIONS_ERROR,
} from '../../../constants/system/actions';

const notificationAddedChannel: ReduxSagaChannel = channel();

export function* getNotificationListData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(NotificationsApi.getNotificationListData, payload);
    yield put({ type: GET_NOTIFICATION_LIST_DATA_SUCCESS, data, payload });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_NOTIFICATION_LIST_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* deleteNotification(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(NotificationsApi.deleteNotification, payload);
    yield put({ type: DELETE_NOTIFICATION_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: DELETE_NOTIFICATION_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* deleteAllNotifications(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(NotificationsApi.deleteAllNotifications, payload);
    yield put({ type: DELETE_ALL_NOTIFICATIONS_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: DELETE_ALL_NOTIFICATIONS_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* readNotifications(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(NotificationsApi.readNotifications, payload);
    yield put({ type: READ_NOTIFICATIONS_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: READ_NOTIFICATIONS_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* notificationAdded(action: ReduxAction): Generator<ReduxAction> {
  const { payload } = action;

  try {
    const subscription: GraphQLSubscription = yield call(
      NotificationsApi.notificationAdded,
      payload,
      (data: ActionPayload): void => {
        notificationAddedChannel.put({ type: NOTIFICATION_ADDED_SUCCESS, data });

        PushNotificationService.addNewWebPushNotification(
          data.user.fullName,
          data.text,
          data.links,
          data.user.photoThumbnail || data.user.photo,
        );
      },
    );

    yield put({ type: NOTIFICATION_ADDED_SUBSCRIBED_SUCCESS, subscription });
  } catch (error: GraphQLError) {
    yield put({ type: NOTIFICATION_ADDED_ERROR, error });
  }
}

export function* watchNotificationAddedChannel(): Generator<ReduxAction> {
  while (true) {
    const action: ReduxAction = (yield take(notificationAddedChannel)) as ReduxAction;

    yield put(action);
  }
}

export default function* notificationSagas(): Generator<ReduxAction> {
  yield all([
    takeEvery(GET_NOTIFICATION_LIST_DATA, getNotificationListData),
    takeEvery(DELETE_NOTIFICATION, deleteNotification),
    takeEvery(DELETE_ALL_NOTIFICATIONS, deleteAllNotifications),
    takeEvery(READ_NOTIFICATIONS, readNotifications),
    takeEvery(NOTIFICATION_ADDED, notificationAdded),
    takeEvery(NOTIFICATION_ADDED, watchNotificationAddedChannel),
  ]);
}
